export default __webpack_public_path__ + "static/media/hardware-trial-kit.763d0870.gif";